import { render } from "./Gifting.vue?vue&type=template&id=3e92dd42&scoped=true"
import script from "./Gifting.vue?vue&type=script&lang=js"
export * from "./Gifting.vue?vue&type=script&lang=js"

import "./Gifting.vue?vue&type=style&index=0&id=3e92dd42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e92dd42"]])

export default __exports__